export const getRoundTwo = (float) =>{
    return Math.round(float * 100) / 100;
}